import { Picture } from '@app/core/business/picture';
import { DownloadableDocument } from '@app/core/business/downloadable-document';
import { Weight } from '@app/core/business/weight';
import { AdditionalGuaranties } from '@app/core/business/product/additional-guaranty';
import { UnavailabilityInfo } from '@app/core/business/product/unavailability-info';
import { NutritionalInformation } from '@app/core/business/product/nutritional-information';
import { PriceByQuantity } from '@app/core/business/PriceByQuantity';
import { SchedulerField } from '@app/core/business/product/scheduler-field';
import { Tag } from './tag';
import { ProductAvailability } from '@app/core/business/product/product-availability';
import { Picto } from './picto';

export class Product {
  code: string;
  displayCode: string;
  ean: string;
  brand: string;
  brandUrl: string;
  label: string;
  fullLabel: string;
  remarque?: string;
  pictures: Picture[];
  origin?: string;
  size?: string;
  isFavorite: boolean;
  ingredients: string;
  discount: boolean;
  unpackedQuantity?: number;
  allergens: string[];
  documents: DownloadableDocument[];
  outer: number;
  weight: Weight;
  tags?: Tag[];
  pictos?: Picto[];
  price: PriceByQuantity[];
  additionalGuaranties?: AdditionalGuaranties[];
  unavailabilityInfo?: UnavailabilityInfo;
  averageStoreTurnover?: string;
  averageShortage?: string;
  availability: ProductAvailability;
  new?: boolean;
  nutritionalInformations?: NutritionalInformation[];
  additionalInformations?: string;
  schedulerFields?: SchedulerField[];
  useByDate?: string;
  frVatLevel?: string;
  availabilityRefreshRate: number;
  estArticleVTF?: boolean;
  codeArticleVTF?: string;
  flux?: string;
  typeProduit?: string;
  articlePLV?: boolean;
  articleTopExtranet?: boolean;
  articleStar?: boolean;
  remisesBonus?: boolean;
  dateCreationArticle?: string;
  paysTransformation?: string;
  departementTransformation?: string;
  isPrecommande?: boolean;
  isDateCourte?: boolean;
  score?: string;
  isBonnesAffaires?: boolean;
  contratDateFournisseur?: string;
  contratDateGaranti?: string;
  ddmIndicative?: string;
}
